import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './component/layout';
import Devices from './page/test';
import BulkSend from './page/bulkSend';



function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* All routes inside here will have the Sidebar and Header */}
        <Route path="/" element={<Layout />}>
          <Route path='/' element={<Devices/>} />
          <Route path='/bulk-send' element={<BulkSend/>}/>
          
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;